import Nullstack from 'nullstack';
export default function IconIdOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-id-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h10a3 3 0 0 1 3 3v10m-1.437 2.561c-.455 .279 -.99 .439 -1.563 .439h-12a3 3 0 0 1 -3 -3v-10c0 -1.083 .573 -2.031 1.433 -2.559"
  }), "   ", Nullstack.element("path", {
    d: "M8.175 8.178a2 2 0 1 0 2.646 2.65"
  }), "   ", Nullstack.element("path", {
    d: "M15 8h2"
  }), "   ", Nullstack.element("path", {
    d: "M16 12h1"
  }), "   ", Nullstack.element("path", {
    d: "M7 16h9"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}